import { InfoCenterFile } from "./InfoCenterFile";

export class NewsItem {
  constructor() {
    this.NewsItemID = 0;
    this.Title = "";
    this.Description = "";
    this.Link = "";
    this.ImagePath = "";
    this.ImageName = "";
    this.Type = 'directlink';
    this.SortOrder = 0;
  }

  public NewsItemID: number;
  public Title: string;
  public Description: string;
  public Link: string;
  public CreatedDate: Date;
  public CreatedBy: string;
  public UpdatedDate: Date;
  public UpdatedBy: string;
  public ImagePath: string;
  public ImageName: string;
  public ImageFile: File;
  public Type: string;
  public InfoCenterFileID: string;
  public InfoCenterFile: InfoCenterFile;
  public SortOrder: number;
}
